<script>
	import ModalAlert from './../components/Modals/ModalAlert.svelte';
import Spinner from './../components/Elements/Spinner.svelte';
import { selectData } from "../libraries/selectData";
import { parseDate } from "../libraries/parseDate";
import { random_string } from '../libraries/random_string';
import { SubscriptionsStore } from './SubscriptionsStore';
export let subscriptions = [];
export let lang;
export let all_plans;
export let all_addons;
export let tripod_plans;
export let currency = tripod_plans.currency;
let rendered_data = $SubscriptionsStore.rendered_data;
let atLeastOneSubscription = $SubscriptionsStore.atLeastOneSubscription ;
let translations = tripod_plans.lang;
let links = tripod_plans.links.currentMemberships;
let showOnly = tripod_plans.showOnly ?? false;
let registered_subscriptions = [];
let registered_plans = [];


function getStripeSubs(){
    return registered_plans;
}

$: {
    if($SubscriptionsStore.registered_plans){
        registered_plans = $SubscriptionsStore.registered_plans
    }
}




tripod_plans.cancelProduct = tripod_plans.cancelProduct || function(){}


function onCancelProduct(subscription){
    let id = "cancel-"+random_string(6);
    new ModalAlert({
        target: document.body,
        props: {
            content: `
                <h2>
                    ¿Deseas cancelar esta membresía?
                </h2>
                <p class="has-text-center">
                    <strong class="has-text-danger">Esta acción no se puede deshacer.</strong>
                <br>      
                    Antes de proceder debe saber que:
                </p>
                <ol class="has-text-left" style="margin-left: 14px;">
                    <li>La cancelación del servicio va a tomar efecto al finalizar el período actual.</li>
                    <li>No se aplicarán más cargos recurrentes en tu tarjeta.</li>
                    <li>Puede seguir usando 3pod hasta que el tiempo restante del período actual termine.</li>
                    <li>Se puede suscribir de nuevo luego de finalizar el período de cancelación.</li>
                </ol>
            `,
            cancel_button: "Volver",
            confirm_button: "Cancelar Membresía",
            classesConfirm: "is-outlined is-light is-fullwidth has-text-danger has-background-white",
            classesCancel: "is-primary has-text-white is-fullwidth",
            onConfirm: ()=>{
                let input = document.getElementById(id);
                tripod_plans.cancelProduct(subscription, input);
            },
            onCancel: ()=>{
                
            }
        }
    })    
}


</script>
<style>
.box-memberships{
    color: #fff;
    background: #fff;
    border: 1px solid var(--color-extralightGrey);
    box-shadow: none;
}
.table-currentMemberships-container .field{
    display: flex;
    align-items: center;
    min-height: 38px;
    color: #fff;
}
table{
    margin-top: 1.25rem;
    background: transparent !important;
}
.tag-interval{
    background: var(--color-primary-gradient) !important;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
}
.container-box{
    max-width: 768px;
    justify-content: center;
    align-items: center;
    margin: auto;
}
.container-box .field{
    min-width: 70%;
}
.box-memberships{
    width: 100%;
    max-width: 640px;
    min-width: 320px;
}
.container-current-memberships{
    display: flex;
    justify-content: center;
}
</style>
{#if typeof subscriptions === "object"}
    {#if $SubscriptionsStore.registered_plans.length > 0}
        <section class="columns is-multiline is-centered">
            <div class="column is-12 container-current-memberships">
                <div class="box box-memberships">
                    <div class="container-box is-flex">
                        <div class="field">
                            {#if $SubscriptionsStore.rendered_data === true}
                                <header>
                                    <h2 class="fw800 is-size-4 has-text-left">
                                        {lang.currentMemberships.title} 
                                        <span class="is-size-7 fw200">
                                            <a href="{links.invoiceData}" class="has-text-dark is-underlined">
                                                <!-- {lang.currentMemberships.invoiceInfo} -->
                                            </a>
                                        </span>
                                    </h2>
                                </header>
                                <main>
                                    <table class="is-fullwidth table-currentMemberships-container is-hoverable table">
                                        {#if all_plans !== false && $SubscriptionsStore.atLeastOneSubscription === true}

                                            {#each $SubscriptionsStore.registered_plans.filter(( subscription )=>{
                                                
                                                let list = all_plans;
                                                if(subscription.is_addon === true){
                                                    list = all_addons;
                                                }
                                                
                                                let plan = selectData(list, "__id__", subscription.id_plan);

                                                subscription.internal_plan = plan;
                                                
                                                let stripe_sub = selectData(getStripeSubs(), "id_plan", subscription.id_plan) ?? false;
                                                
                                                subscription.canceled = false;
                                                if(subscription?.is_sub_canceled?.canceled_at){                                                    
                                                    /**
                                                     * On subscription canceled
                                                     */
                                                    subscription.canceled = true;
                                                    let cancelData = subscription?.is_sub_canceled;
                                                    let created = cancelData.created,
                                                    canceled_at = cancelData.canceled_at,
                                                    current_period_end = cancelData.current_period_end;

                                                    /**
                                                     * Si es mayor a un mes
                                                     * entonces es year
                                                     * sino month
                                                     */
                                                    let interval = ((current_period_end - created)/3600)/30 > 27 ? "year" : "month";

                                                    
                                                    subscription.interval = interval;  
                                                    subscription.endAt = parseDate.onlydate(current_period_end, "Y-m-d");
                                                    subscription.startAt = parseDate.onlydate(created, "Y-m-d"); 
                                                }           

                                                
                                                subscription.has_been_terminated = false;
                                                if(subscription.status === "canceled"){
                                                    subscription.canceled = true;
                                                    subscription.has_been_terminated = true;
                                                    return subscription;
                                                }
                                                
                                                
                                                if(stripe_sub === false){
                                                    return subscription;
                                                }
                                               
                                                subscription.stripePlan = stripe_sub.plan;
                                                subscription.priceInNextPeriod = stripe_sub.price.unit_amount / 100;
                                                let percent_off = stripe_sub?.discount?.coupon?.percent_off ?? null;
                                                if(typeof percent_off === "number"){
                                                    subscription.priceInNextPeriod = subscription.priceInNextPeriod-((percent_off/100)*subscription.priceInNextPeriod);
                                                }

                                                subscription.nextInvoice = +(subscription.nextInvoice.toFixed(2));
                                                subscription.priceInNextPeriod = +(subscription.priceInNextPeriod.toFixed(2));
                                                
                                                
                                                subscription.coupon = stripe_sub?.coupon ?? false;
                                                subscription.interval = subscription.stripePlan?.interval ?? "month";

                                                subscription.endAt = parseDate.onlydate(stripe_sub.current_period_end, "Y-m-d");
                                                subscription.startAt = parseDate.onlydate(stripe_sub.current_period_start, "Y-m-d");
                                                
                                                
                                                return subscription;
                                            }) as subscription}
                                                {#if subscription.registered_at_stripe === true && subscription.has_been_terminated === false}
                                                    <tr>
                                                        <td>
                                                            <div class="field">
                                                                <img src="" alt="">
                                                                <h3 class="fw600 has-text-dark">
                                                                    {subscription.internal_plan.name_plan}
                                                                </h3>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="field">
                                                                <div style="width:100%;">
                                                                    {#if subscription.canceled === false && subscription.cancel_at_period_end !== true}
                                                                        <p class=" has-text-centered">
                                                                            <span class="tag is-rounded is-small is-primary tag-interval">
                                                                                {translations[subscription.interval] ?? "M"}
                                                                            </span>
                                                                        </p>
                                                                        <p class="is-size-7 has-text-centered">
                                                                            <!-- svelte-ignore a11y-missing-attribute -->
                                                                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                                                                            <a on:click="{()=>{ onCancelProduct(subscription) }}" class="is-underlined has-text-dark pointer">
                                                                                {translations.currentMemberships.cancel}
                                                                            </a>
                                                                        </p>
                                                                        {:else}
                                                                            <p class="is-size-7 has-text-centered">
                                                                                {translations.currentMemberships.canceled}
                                                                            </p>
                                                                    {/if}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="field">
                                                                <div>
                                                                    {#if subscription.canceled === false}
                                                                        <p class="fw600">
                                                                            <span>
                                                                                {currency[0]}
                                                                            </span>
                                                                            {subscription.priceInNextPeriod}
                                                                            <span>
                                                                                {currency[1]}
                                                                            </span>/ 
                                                                            <span class="is-lowercase">
                                                                                {translations[subscription.interval] ?? "M"}       
                                                                            </span>
                                                                        </p>
                                                                    {/if}
                                                                    <p>
                                                                        <span class="fw200 is-size-7">
                                                                            {#if subscription.canceled === false && subscription.cancel_at_period_end !== true}
                                                                                {translations.currentMemberships.renewal}: 
                                                                                {:else}
                                                                                    {translations.currentMemberships.endAt}: 
                                                                            {/if}
                                                                            <span>
                                                                                {subscription.endAt}
                                                                            </span>
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                {/if}
                                            {/each}
                                        {/if}
                                    </table>
                                    {#if $SubscriptionsStore.atLeastOneSubscription === false}
                                        <div>
                                            <p class="has-text-centered has-text-dark">
                                                {translations.currentMemberships.withOutMemberships}
                                                <br>
                                                <br>
                                            </p>
                                        </div>
                                    {/if}
                                </main>
                                {:else}
                                    <Spinner />
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </section>    
    {/if}
{/if}